module.exports = require("react-plotly.js/factory");